import { useParams } from "react-router-dom";
import { Sparkles } from "lucide-react";
import ProjectWeeklyUpdatesPanel from "@/components/ProjectWeeklyUpdatesPanel";

/* Route wrapper that reads the project id from the URL params. Kept as a
   thin layer so ProjectWeeklyUpdatesPanel stays self-contained and can
   theoretically be embedded elsewhere later (e.g. Launchpad). */

export default function ProjectUpdatesPage() {
  const { id } = useParams();
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-10">
      <div className="flex items-center gap-3 mb-2">
        <Sparkles className="w-5 h-5 text-amber-500" />
        <div className="text-overline text-zinc-500">AI-Generated · Weekly</div>
      </div>
      <h1 className="font-heading text-3xl font-light text-zinc-100 mb-1">
        Project Updates
      </h1>
      <p className="text-sm text-zinc-500 mb-8">
        Client-facing status recaps generated every Monday morning.
      </p>
      <ProjectWeeklyUpdatesPanel projectId={id} />
    </div>
  );
}
